export default "__VITE_ASSET__de10f03e__"